import Notas from "./Notas";

export default Notas;
